import React, { useState } from 'react';
import { Breadcrumb } from "antd";
import { Outlet, useParams } from 'react-router-dom';
import { useAuth, useNavigation } from '../../components/Auth';
import { Context, ServiceContext, SetContext, useUserContext } from '../../components/Context';
import { useSelector } from 'react-redux';

var _ = require('lodash');

function LineDescription(props) {
    const { title, value, unit, bold } = props;
    return (
        <div>
            <span style={(bold) ? { fontWeight: "600", fontSize: "18px" } : {}}>
                {title} {value} {unit}
            </span>
        </div>
    );
}
function Description(props) {
    const { title, value, unit } = props;
    return (
        <div>
            <div style={{ fontWeight: "600", fontSize: "18px" }}>
                {title}:
            </div>
            <div>
                {value} {unit}
            </div>
        </div>
    );
}
export default function Dictionary(props) {
    let { name } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const navigation = useNavigation(); // navigation(-1) - goBack
    const [service, setService] = useState();
    const [context, setContext] = useState();
    const meta = useSelector(state => state.meta);

    const label = (meta && meta[name.toLowerCase()])?meta[name.toLowerCase()].label:undefined;

    return (<>
        <ServiceContext.Provider value={service}>
            <div style={{ padding: "0 24px" }}>
                <Breadcrumb style={{ margin: '16px 0' }}>
                    <Breadcrumb.Item>Справочники</Breadcrumb.Item>
                    {label && <Breadcrumb.Item>{label}</Breadcrumb.Item>}
                </Breadcrumb>
            </div>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360, height: "100%" }}>
                <Context.Provider value={context}>
                    <SetContext.Provider value={setContext}>
                        <Outlet />
                    </SetContext.Provider>
                </Context.Provider>
            </div>
        </ServiceContext.Provider>
    </>);
}